<div
  class="host-input-with-error"
  [class.host-has-error]="showError">
  <div class="input-with-error-tip">
    {{ i18nErrorKey 
        ? (i18nErrorKey | translate) 
        : errorText }}
  </div>
  <div class="input-with-error-content">
    <ng-content></ng-content>
  </div>
</div>
